import {
    Box,
    Button,
    Checkbox,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import Layout from "components/structure/Layout";
  import React, { useCallback, useContext } from "react";
  import { useEffect } from "react";
  import { useState } from "react";
  import CommonService from "services/CommonService";
  import RoleService from "services/RoleService";
  import CheckboxTick from "assets/CheckboxTick.svg";
  import CheckboxUntick from "assets/CheckboxUntick.svg";
  import { AuthData } from "auth/AuthWarpper";
  import { useLocation, useNavigate } from "react-router-dom";
  import { SnackbarContext } from "context/snackBarContext";
  import UserService from "services/UserService";
  import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
  import dayjs from "dayjs";
  import UserCreationService from "services/UserCreationService";
  import DelegationService from "services/DelegationService";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

  
  const RoleDelegation = () => {
    
  const {t,i18n} = useTranslation()
    const location = useLocation();
    const profileOptions = ["Global", "Local"];
    const { user } = AuthData();
    const navigate = useNavigate();
    const { rowData ,fromUrl } = location.state || {};
    const { setOpenAlert, setSeverity, setMessage, handleClose } =
      useContext(SnackbarContext);
    const [userName, setUserName] = useState(rowData?.userName || "");
    const [isActive, setIsActive] = useState(
      rowData?.active === "Active" ? "Active" : "Active"
    );
  
    const [formData, setFormData] = useState({
      profile: rowData?.batOneId || "",
      fieldTechnician: "",
      role: rowData?.profileId || "",
      serviceNumber: rowData?.serviceNumber || "",
      remarks: rowData?.remarks || "",
      countryCode: rowData?.countryCode || "",
      fromBatId: "",
      toBatId: "",
    });
  
    const [selected, setSelected] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = React.useState(false);
    const [StartDate, setStartDate] = useState(rowData?.endDate || "");
  
    const [roleOptions, setRoleOptions] = useState([]);
    const [countries, setCountries] = useState([]);
  
    const fetchRoles = async () => {
      try {
        const response = await RoleService.getActiveRoles();
        if (response.data?.statusCode === 200) {
          setRoleOptions(response.data.response);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
  
    const fetchCountries = async () => {
      try {
        const response = await CommonService.fetchCountries();
        console.log({ response });
        if (response.data?.statusCode === 200) {
          setCountries(response.data.response);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };
  
    useEffect(() => {
      fetchRoles();
      fetchCountries();
    }, []);
  
    const handleChange = (event) => {
      const { name, value } = event.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };
  
    const isAllSelected =
      countries.length > 0 && selected.length === countries.length;
  
    const handleChangeCountry = (event) => {
      const { name, value } = event.target;
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        // setErrors({});
        // await validationSchema.validate(formData, { abortEarly: false });
  
        // Constructing the payload object
        const payload = {
          isActive: isActive === "Active" ? true : false,
          toBATID: formData.profile,
          fromBATID: user?.batOneId,
          startDate: StartDate,
          endDate: endDate,
          createdByUser: user.userName,
          modifiedByUser: user.userName,
          createdDateTimeUTC: new Date().toISOString(),
          modifiedDateTimeUTC: new Date().toISOString(),
        };
  
        // "createdDateTimeUTC": "2024-10-08T17:03:08.804Z",
        // "createdByUser": "string",
        // "modifiedDateTimeUTC": "2024-10-08T17:03:08.804Z",
        // "modifiedByUser": "string",
        // "fromBATID": 0,
        // "toBATID": 0,
        // "startDate": "2024-10-08T17:03:08.804Z",
        // "endDate": "2024-10-08T17:03:08.804Z",
        // "isActive": true
  
        // userId
  
        // "userName": "Rahul Dutta",
        // "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
        // "batOneId": 85189949,
        // "countryCode": "KEN",
        // "email": "rahul.dutta@itcinfotech.com",
        // "active": true,
        // "isDeleted": false,
        // "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
        // "createdByUser": "ADMIN",
        // "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
        // "modifiedByUser": "Rahul Dutta"
  
        // Make a POST request using Axios
        const response = await DelegationService.createDelegation(payload);
        setLoading(false);
        if (response.status === 201) {
          // Show success snackbar
          navigate(`/${fromUrl}`);
          setSeverity("success");
          setMessage("Added successfully");
          setOpenAlert(true);
        } else {
          console.error("Failed to submit form");
          // Show error snackbar
          setSeverity("error");
          setMessage("Failed to submit form");
          setOpenAlert(true);
        }
      } catch (error) {
        setLoading(false);
        let newError = {};
        if (error?.name && error.name === "ValidationError") {
          error?.inner?.forEach((err) => {
            newError[err.path] = err.message;
            setErrors(newError || error?.message);
            return;
          });
        } else {
          setSeverity("error");
          setMessage(error?.response?.data?.message || error?.message);
          setOpenAlert(true);
        }
      }
    };
  
    const handleSubmitMulti = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        // setErrors({});
        // await validationSchema.validate(formData, { abortEarly: false });
  
        // Constructing the payload object
        const payload = {
          isActive: isActive === "Active" ? true : false,
          toBATID: formData?.toBatId,
          fromBATID: formData?.fromBatId,
          startDate: StartDate,
          endDate: endDate,
          createdByUser: user.userName,
          modifiedByUser: user.userName,
          createdDateTimeUTC: new Date().toISOString(),
          modifiedDateTimeUTC: new Date().toISOString(),
        };
  
        // "createdDateTimeUTC": "2024-10-08T17:03:08.804Z",
        // "createdByUser": "string",
        // "modifiedDateTimeUTC": "2024-10-08T17:03:08.804Z",
        // "modifiedByUser": "string",
        // "fromBATID": 0,
        // "toBATID": 0,
        // "startDate": "2024-10-08T17:03:08.804Z",
        // "endDate": "2024-10-08T17:03:08.804Z",
        // "isActive": true
  
        // userId
  
        // "userName": "Rahul Dutta",
        // "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
        // "batOneId": 85189949,
        // "countryCode": "KEN",
        // "email": "rahul.dutta@itcinfotech.com",
        // "active": true,
        // "isDeleted": false,
        // "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
        // "createdByUser": "ADMIN",
        // "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
        // "modifiedByUser": "Rahul Dutta"
  
        // Make a POST request using Axios
        const response = await DelegationService.createDelegation(payload);
        setLoading(false);
        if (response.status === 201) {
          // Show success snackbar
          navigate("/roleCreation");
          setSeverity("success");
          setMessage("Added successfully");
          setOpenAlert(true);
        } else {
          console.error("Failed to submit form");
          // Show error snackbar
          setSeverity("error");
          setMessage("Failed to submit form");
          setOpenAlert(true);
        }
      } catch (error) {
        setLoading(false);
        let newError = {};
        if (error?.name && error.name === "ValidationError") {
          error?.inner?.forEach((err) => {
            newError[err.path] = err.message;
            setErrors(newError || error?.message);
            return;
          });
        } else {
          setSeverity("error");
          setMessage(error?.response?.data?.message || error?.message);
          setOpenAlert(true);
        }
      }
    };
  
    const [profileData, setProfileData] = useState([]);
    const [match, setMatch] = useState(false);
  
    const handleChangeText = (e) => {
      setFormData({ ...formData, profile: e.target.value });
    };
  
    const [batData, setBatData] = useState("");
  
    const [open, setOpen] = useState(false);
  
  
    //   useEffect(() => {
    //     const fetchProfileData = async () => {
    //       if (formData.profile) {
    //         try {
    //             const response = await DelegationService.checkSameRole({
    //                 loginBatID: user?.batOneId,
    //                 delegatorBATID: formData?.profile,
    //               });
  
    //           console.log("res", response);
  
    //           setMatch(response?.data?.response);
    //           setUserName(
    //             `${response?.data?.response?.givenName ?? ""} ${
    //               response?.data?.response?.surName ?? ""
    //             }`.trim()
    //           );
  
    //           // Assuming the response contains a list of options in response.data
    //         } catch (error) {
    //           console.error("Error fetching profile data:", error);
    //           console.error("Failed to submit form");
    //           // Show error snackbar
    //           setSeverity("error");
    //           setMessage(error?.response?.data?.message);
    //           setOpenAlert(true);
    //         }
    //       }
  
    //     };
  
    //     fetchProfileData();
    //   }, [formData.profile]);
  
    //   useEffect(() => {
    //     const fetchProfileData = async () => {
    //       if (match) {
    //         try {
    //             const response = await UserService.FindAdUser(formData.profile);
  
    //           console.log("res", response);
  
    //           setMatch(response?.data?.response);
    //           setUserName(
    //             `${response?.data?.response?.givenName ?? ""} ${
    //               response?.data?.response?.surName ?? ""
    //             }`.trim()
    //           );
  
    //           // Assuming the response contains a list of options in response.data
    //         } catch (error) {
    //           console.error("Error fetching profile data:", error);
    //           console.error("Failed to submit form");
    //           // Show error snackbar
    //           setSeverity("error");
    //           setMessage(error?.response?.data?.message);
    //          
    //     fetchProfileData();
    //   }, [])
  
    const fetchProfileData = useCallback(
      debounce(async (query) => {
        setLoading(true);
          if (query.profile) {
          try {
            const response = await DelegationService.checkSameRole({
              loginBatID: query?.batOneId,
              delegatorBATID: query?.profile,
            });
  
  
            // Only update state if the response is different
            if (response?.data?.response !== match) {
              setMatch(response?.data?.response);
            }
          } catch (error) {
            console.error("Error fetching profile data:", error);
            setSeverity("error");
            setMessage(error?.response?.data?.message);
            setOpenAlert(true);
          }
        }
      }, 1000), // 1000ms debounce delay
      [] // Ensure the debounce function is only created once
    );

    useEffect(() => {
      fetchProfileData({profile:formData.profile, batOneId:user?.batOneId});
    }, [formData.profile, user?.batOneId, match]);
  

   
  

    const [multiMatch, setMultiMatch] = useState(false);
  
    useEffect(() => {
      let isMounted = true; // Track if the component is mounted
  
      const fetchProfileData = async () => {
        if (formData.fromBatId && formData.toBatId) {
          try {
            const response = await DelegationService.checkSameRole({
              loginBatID: formData.fromBatId,
              delegatorBATID: formData.toBatId,
            });
  
  
            // Only update state if the component is still mounted and the response is different
            if (isMounted && response?.data?.response !== multiMatch) {
              setMultiMatch(response?.data?.response);
            }
          } catch (error) {
            if (isMounted) {
              console.error("Error fetching profile data:", error);
              setSeverity("error");
              setMessage(error?.response?.data?.message || "An error occurred");
              setOpenAlert(true);
            }
          }
        }
      };
  
      fetchProfileData();
  
      return () => {
        isMounted = false; // Cleanup function to avoid state updates if unmounted
      };
    }, [formData.fromBatId, formData.toBatId, multiMatch]); // Add 'match' to dependency array if you want the effect to re-run when it changes
  
    useEffect(() => {
      const fetchUserData = async () => {
        if (match) {
          try {
            const response = await UserService.FindAdUser(formData.profile);
  
  
            // Only update state if the response is different
            setBatData(response?.data?.response);
            setUserName(
              `${response?.data?.response?.givenName ?? ""} ${
                response?.data?.response?.surName ?? ""
              }`.trim()
            );
          } catch (error) {
            console.error("Error fetching user data:", error);
            setSeverity("error");
            setMessage("User not found");
            setOpenAlert(true);
          }
        }
      };
  
      fetchUserData();
    }, [match]); // Depend on match to avoid unnecessary re-renders
  
    const [userEmail, setUserEmail] = useState("");
  
    useEffect(() => {
      const fetchUserData = async () => {
        if (formData.fromBatId) {
          try {
            const response = await UserService.FindAdUser(formData.fromBatId);
  
            console.log("res", response);
  
            // Only update state if the response is different
            setUserName(
              `${response?.data?.response?.givenName ?? ""} ${
                response?.data?.response?.surName ?? ""
              }`.trim()
            );
            setUserEmail(response?.data?.response?.mail);
          } catch (error) {
            console.error("Error fetching user data:", error);
            setSeverity("error");
            setMessage("User not found");
            setOpenAlert(true);
          }
        }
      };
  
      fetchUserData();
    }, [formData.fromBatId]);
  
    const [toUserName, setToUserName] = useState("");
    const [toEmail, setToEmail] = useState("");
  
  
    useEffect(() => {
      const fetchUserData = async () => {
        if (multiMatch) {
          try {
            const response = await UserService.FindAdUser(formData.toBatId);
  
            console.log("res", response);
  
            // Only update state if the response is different
            setToUserName(
              `${response?.data?.response?.givenName ?? ""} ${
                response?.data?.response?.surName ?? ""
              }`.trim()
            );
  
            setToEmail(response?.data?.response?.mail);
          } catch (error) {
            console.error("Error fetching user data:", error);
            setSeverity("error");
            setMessage("User not found");
            setOpenAlert(true);
          }
        }
      };
  
      fetchUserData();
    }, [multiMatch]);
  
  
    const toggleIsActive = () => {
      setIsActive((prevIsActive) =>
        prevIsActive === "Active" ? "InActive" : "Active"
      );
    };
  
    const handleChangeDate = (date) => {
      setStartDate(date); // Store the selected date
    };
  
    const [endDate, setEndDate] = useState("");
  
    const [openEnd, setOpenEnd] = useState(false);
  
    const handleChangeDateEnd = (date) => {
      setEndDate(date); // Store the selected date
    };
  
    return (
      <LayoutAccessManagement>
        <Box sx={{ paddingBottom: "150px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "65vh",
              background: "#f0f3f6",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
              padding: "25px",
              borderRadius: "6px",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {toUserName === "" && (
              <Box
                sx={{
                  background: "#ffffff",
                  width: "473px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  borderRadius: "16px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                }}
              >
                <Box sx={{ borderBottom: "2px solid #CFD5E0", p: 2 }}>
                  <TextField
                    id="profile"
                    label={t("batOneId")}
                     value={formData.profile}
                    name="profile"
                    onChange={handleChangeText}
                    disabled={batData?.givenName}
                    fullWidth
                  ></TextField>
                </Box>
  
                {batData !== "" && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: 500,
                      color: "#191E31",
                      borderBottom: "2px solid #CFD5E0",
                      p: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                    {t("administratorAccess.name")}:{" "}
                      {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                    {t("administratorAccess.email")}: {batData?.mail ?? ""}
                    </Typography>
                  </Box>
                )}
                {batData !== "" && (
                  <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        sx={{
                          width: {
                            sx: "100%",
                            md: "100% !important",
                            xl: "100%",
                          },
                        }}
                        components={["DatePicker"]}
                      >
                        <DatePicker
                          sx={{
                            width: {
                              sx: "100%",
                              md: "100% !important",
                              xl: "100%",
                            },
                          }}
                          id="selectDate"
                          name="selectDate"
                          open={open}
                          onClose={() => setOpen(false)}
                          label={t("administratorAccess.selectDate")}
                      
                          format="DD/MM/YYYY"
                          value={StartDate ? dayjs(StartDate) : null}
                          onChange={(date) => handleChangeDate(date)}
                          renderInput={(params) => (
                            <TextField {...params} error={false} helperText="" />
                          )}
                          slotProps={{
                            field: {
                              readOnly: true,
                            },
                            textField: {
                              onClick: () => setOpen(true),
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        sx={{
                          width: {
                            sx: "100%",
                            md: "100% !important",
                            xl: "100%",
                            paddingTop:"20px"
                          },
                        }}
                        components={["DatePicker"]}
                      >
                        <DatePicker
                          sx={{
                            width: {
                              sx: "100%",
                              md: "100% !important",
                              xl: "100%",
                            },
                          }}
                          id="endDate"
                          name="endDate"
                          open={openEnd}
                          onClose={() => setOpenEnd(false)}
                          label={t("administratorAccess.endDate")}
                          format="DD/MM/YYYY"
                          value={endDate ? dayjs(endDate) : null}
                          onChange={(date) => handleChangeDateEnd(date)}
                          renderInput={(params) => (
                            <TextField {...params} error={false} helperText="" />
                          )}
                          slotProps={{
                            field: {
                              readOnly: true,
                            },
                            textField: {
                              onClick: () => setOpenEnd(true),
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                )}
  
                {batData !== "" && (
                  <>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          pb: 2,
                          cursor: "pointer",
                          borderBottom: "2px solid #CFD5E0",
                        }}
                        onClick={toggleIsActive}
                      >
                        <img
                          src={
                            isActive === "Active" ? CheckboxTick : CheckboxUntick
                          }
                          alt="checkbox"
                        />
                        <Typography>
                          {isActive === "Active" ? "Active" : "Inactive"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        gap: "20px",
                        p: 2,
                      }}
                    >
                      <Button
                        sx={{
                          borderRadius: 2,
                          background: "#102A62",
                          height: 54,
                          color: "#ffffff",
                          fontWeight: 600,
                          backgroundColor: "#737D86",
                          width: { xs: "100%", md: "156px" },
                          "&:hover": {
                            backgroundColor: "#737D86",
                          },
                        }}
                        onClick={() => navigate(`/${fromUrl}`)}
                      >
                        {t("back")}
                      </Button>
                      <Button
                        sx={{
                          borderRadius: 2,
                          background: "#EF7D00",
                          color: "#ffffff",
                          fontWeight: 600,
                          height: 54,
                          width: { xs: "100%", md: "156px" },
                          "&:hover": {
                            backgroundColor: "#EF7D00",
                          },
                        }}
                        disabled={loading}
                        onClick={handleSubmit}
                      >
                               {t("assign")}
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            )}
            {/* {match === false && (
              <Box
                sx={{
                  background: "#ffffff",
                  width: "473px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  borderRadius: "16px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    fontWeight: 500,
                    color: "#191E31",
                    p: 2,
                  }}
                >
                  Other Delegation
                </Box>
                
                <Box sx={{p:2}}>
                <TextField
                  id="profile"
                  label="From Bat OneID"
                  value={formData.fromBatId}
                  name="fromBatId"
                  onChange={handleChange}
                  fullWidth
                ></TextField>
                </Box>
  
                {toUserName !== "" && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: 500,
                      color: "#191E31",
                      borderBottom: "2px solid #CFD5E0",
                      p: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                      Name: {userName}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                      Email: {userEmail}
                    </Typography>
                  </Box>
                )}
                   <Box sx={{p:2}}>
                <TextField
                  id="profile"
                  label="To Bat OneID"
                  value={formData.toBatId}
                  name="toBatId"
                  onChange={handleChange}
                  fullWidth
                ></TextField>
                </Box>
                {toUserName !== "" && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: 500,
                        color: "#191E31",
                        borderBottom: "2px solid #CFD5E0",
                        p: 2,
                      }}
                    >
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        Name: {toUserName}
                      </Typography>
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        Email: {toEmail}
                      </Typography>
                    </Box>
                    <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          sx={{
                            width: {
                              sx: "100%",
                              md: "100% !important",
                              xl: "100%",
                            },
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            sx={{
                              width: {
                                sx: "100%",
                                md: "100% !important",
                                xl: "100%",
                              },
                            }}
                            id="selectDate"
                            name="selectDate"
                            open={open}
                            onClose={() => setOpen(false)}
                            label="Select Date"
                            format="DD/MM/YYYY"
                            value={StartDate ? dayjs(StartDate) : null}
                            onChange={(date) => handleChangeDate(date)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={false}
                                helperText=""
                              />
                            )}
                            slotProps={{
                              field: {
                                readOnly: true,
                              },
                              textField: {
                                onClick: () => setOpen(true),
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          sx={{
                            width: {
                              sx: "100%",
                              md: "100% !important",
                              xl: "100%",
                            },
                          }}
                          components={["DatePicker"]}
                        >
                          <DatePicker
                            sx={{
                              width: {
                                sx: "100%",
                                md: "100% !important",
                                xl: "100%",
                              },
                            }}
                            id="endDate"
                            name="endDate"
                            open={openEnd}
                            onClose={() => setOpenEnd(false)}
                            label="End Date"
                            format="DD/MM/YYYY"
                            value={endDate ? dayjs(endDate) : null}
                            onChange={(date) => handleChangeDateEnd(date)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={false}
                                helperText=""
                              />
                            )}
                            slotProps={{
                              field: {
                                readOnly: true,
                              },
                              textField: {
                                onClick: () => setOpenEnd(true),
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          pb: 2,
                          cursor: "pointer",
                          borderBottom: "2px solid #CFD5E0",
                        }}
                        onClick={toggleIsActive}
                      >
                        <img
                          src={
                            isActive === "Active" ? CheckboxTick : CheckboxUntick
                          }
                          alt="checkbox"
                        />
                        <Typography>
                          {isActive === "Active" ? "Active" : "Inactive"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        gap: "20px",
                        p: 2,
                      }}
                    >
                      <Button
                        sx={{
                          borderRadius: 2,
                          background: "#102A62",
                          height: 54,
                          color: "#ffffff",
                          fontWeight: 600,
                          backgroundColor: "#737D86",
                          width: { xs: "100%", md: "156px" },
                          "&:hover": {
                            backgroundColor: "#737D86",
                          },
                        }}
                        onClick={() => navigate("/userCreation")}
                      >
                        Back
                      </Button>
                      <Button
                        sx={{
                          borderRadius: 2,
                          background: "#EF7D00",
                          color: "#ffffff",
                          fontWeight: 600,
                          height: 54,
                          width: { xs: "100%", md: "156px" },
                          "&:hover": {
                            backgroundColor: "#EF7D00",
                          },
                        }}
                        onClick={handleSubmitMulti}
                      >
                        ASSIGN
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            )} */}
          </Box>
        </Box>
      </LayoutAccessManagement>
    );
  };
  
  export default RoleDelegation;
  